import styled from "styled-components";

// Zajednički stilovi za admin detail stranice
// (Detalji korisnika / porudžbine / kursa / aplikacije za sertifikat)

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;

  svg {
    color: var(--accent);
  }
`;

export const BackButton = styled.button`
  padding: 10px 20px;
  border: 2px solid var(--accent-light);
  border-radius: 20px;
  background: transparent;
  color: var(--text-secondary);
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: var(--accent-light);
    border-color: var(--accent);
    color: var(--accent);
    transform: translateY(-2px);
  }
`;

export const PageCard = styled.div`
  background: var(--surface);
  border-radius: 15px;
  border: 1px solid var(--accent-light);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  max-width: 900px;
  overflow: hidden;
`;

export const PageCardBody = styled.div`
  padding: 30px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const PageActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 30px;
  border-top: 1px solid var(--accent-light);
  background: var(--surface-light, #faf7f8);

  @media (max-width: 768px) {
    padding: 15px 20px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0;
`;

export const ErrorState = styled.div`
  background: var(--surface);
  border-radius: 15px;
  border: 1px solid var(--accent-light);
  padding: 60px 30px;
  text-align: center;
  color: var(--text-muted);
  max-width: 900px;

  h3 {
    color: var(--text-primary);
    margin: 0 0 10px 0;
  }

  p {
    margin: 0 0 20px 0;
  }
`;
